export default function MySQL_LOCALTIMESTAMP() {
  return (
    <div>
      <h2>MySQL_LOCALTIMESTAMP</h2>    </div>
  );
}